import defaultApiClient from 'hub-http/clients/apiClient';
let apiClient;
export const getApiClient = () => apiClient || defaultApiClient;
export const setApiClient = _apiClient => {
  apiClient = _apiClient;
};